export const actionTypes = {
    FETCH_FEATURED_START: 'FETCH_FEATURED_START',
    FETCH_FEATURED_SUCCESS: 'FETCH_FEATURED_SUCCESS',
    FETCH_FEATURED_FAILED: 'FETCH_FEATURED_FAILED',
};